/* eslint-disable import/no-unresolved */
import { MatxLoadable } from "matx";

const ListValets = MatxLoadable({
  loader: () => import("../views/valet"),
});

const DetailsValets = MatxLoadable({
  loader: () => import("../views/valet/details"),
});

const RelocationValetsList = MatxLoadable({
  loader: () => import("../views/valet/valetRelocation"),
});

const valetRoutes = [
  {
    path: "/valet/list/:id",
    component: DetailsValets,
    permission: ["manager", "account_holder", "customer_service"],
  },
  {
    path: "/valet/list",
    component: ListValets,
    permission: ["manager", "account_holder", "customer_service"],
  },
  {
    path: "/valet/relocation/list",
    component: RelocationValetsList,
    permission: ["manager", "account_holder", "customer_service"],
  },
];

export default valetRoutes;
